<form [formGroup]="amlChecklistForm" novalidate>
  <h4>
    {{ amlQuestionObj.description }}
  </h4>
  <div class="radio-container" fxLayout="row wrap">
    <mat-radio-group
      *ngIf="amlQuestionObj.options && amlQuestionObj.options.length > 0"
      fxFlex="40"
      id="{{ amlQuestionObj.question }}"
      formControlName="{{ amlQuestionObj.question }}"
      matInput
      color="primary">
      <mat-radio-button
        *ngFor="let option of amlQuestionObj.options"
        id="{{ amlQuestionObj.question }}_{{ option.identifier }}"
        [value]="option.value"
        color="primary">
        {{ getTranslation(option.label) }}
      </mat-radio-button>
    </mat-radio-group>
    <mat-form-field
      *ngIf="amlQuestionObj.display_note_field &&
      toggleNoteField(amlQuestionObj.display_note_field_when, amlQuestionObj.question)"
      [fxFlex]="amlQuestionObj.options && amlQuestionObj.options.length > 0 ? 60 : 100"
      floatLabel="never">
      <input
        id="{{ amlQuestionObj.question }}_note"
        type="text"
        matInput
        formControlName="{{ amlQuestionObj.question }}_note"
        placeholder="please enter detail note here" i18n-placeholder
        maxlength="254"/>
    </mat-form-field>
  </div>
</form>